import * as React from "react";
import { Profile } from "../../store/profile/Profile";
import { BaseList } from '../base/baseList';
import GoToTop from "../base/gototop";
import { CheckBox } from '../base/checkbox';
import _ from "underscore";


export interface ProfileListProps {
    selectionEnabled: boolean;
    selectedProfiles?: Array<Profile>;
    list: Array<Profile>;
    hasNextPage: boolean;
    loadNewPage?: () => void;
    startLoading?: boolean;
    onRowClick?: (profileId: string) => void;
    onUnload?: () => void;
}

export class ProfileList extends React.Component<ProfileListProps>{

    constructor(props) {
        super(props);
    }

    private getRows(profileList: Array<Profile>): JSX.Element[] {

        let profileArray = profileList.map(profile => {

            let checkbox = (<React.Fragment></React.Fragment>);

            let isSelected = false;

            if (this.props.selectedProfiles !== undefined && this.props.selectedProfiles != null && this.props.selectedProfiles.length > 0) {
                isSelected = _.some(this.props.selectedProfiles, (c) => c.id == profile.id)
            }

            if (this.props.selectionEnabled == true) {
                checkbox = (
                    <td>
                        <CheckBox isChecked={isSelected} onCheck={(checked: boolean) => { }} />
                    </td>
                )
            }

            let roleName = profile.account !== undefined && profile.account != null
                && profile.account.role !== undefined && profile.account.role != null ? profile.account.role.name : "-";

            return (
                <tr key={profile.id} style={{ cursor: "pointer" }} onClick={() => this.props.onRowClick(profile.id)}>
                    {checkbox}
                    <td>
                        {profile.lastName} {profile.firstName}
                    </td>
                    <td className="d-none d-md-table-cell">
                        {profile.email}
                    </td>
                    <td>
                        {profile.phone}
                    </td>
                    <td className="d-none d-md-table-cell">
                        {roleName}
                    </td>
                </tr >
            )
        });

        return profileArray;

    }

    private getHead(): JSX.Element {

        let thSelection = (<React.Fragment></React.Fragment>);

        if (this.props.selectionEnabled == true) {
            thSelection = (<th>Sel.</th>);
        }

        return (
            <thead>
                <tr className="text-eurorounders">
                    {thSelection}
                    <th>Nome</th>
                    <th className="d-none d-md-table-cell">Email</th>
                    <th>Tel.</th>
                    <th className="d-none d-md-table-cell">Ruolo</th>
                </tr>
            </thead>
        );

    }


    render() {

        return (
            <React.Fragment>
                <BaseList hasNextPage={this.props.hasNextPage} list={this.props.list} active={this.props.startLoading} onEndOfList={this.props.loadNewPage} getElements={(profileList: Array<Profile>) => { return this.getRows(profileList) }} getHead={() => { return this.getHead() }} />
                <GoToTop />
            </React.Fragment>
        )
    }
}